import Modal from '@/shared/Modal';
import type { Permission } from '@/store/geo-test/types';
import { PERMISSION_TITLES, PERMISSIONS } from '@/store/geo-test/types';
import type { ModalProps } from 'antd';
import { Input, Select } from 'antd';
import { useState, type FC, type KeyboardEventHandler } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../WellLoggingOperations/types';
import type { MessageInstance } from 'antd/es/message/interface';
import { useDispatch } from 'react-redux';

type SaveProfileModalProps = {
    messageApi: MessageInstance;
} & ModalProps;

export const SaveProfileModal: FC<SaveProfileModalProps> = ({ messageApi, ...props }) => {
    const handleKeyDown: KeyboardEventHandler<HTMLElement> = e => {
        if (e.key === 'Enter') {
            props.onClose?.({} as React.MouseEvent<HTMLButtonElement>);
        }
    };

    const { geoData, versionId } = useSelector((store: RootState) => store.geoTest);
    const dispatch = useDispatch();
    const { addProfile } = dispatch.geoTest;

    const [profileName, setProfileName] = useState<string>('');
    const [permission, setPermission] = useState<Permission>('private');

    const onSaveProfile = async () => {
        if (!permission) {
            return;
        }
        if (!geoData || !versionId) {
            messageApi.error('Для сохранения нужен построенный профиль');
            return;
        }
        await addProfile({ profileName, permission, messageApi });
        props.onCancel?.({} as React.MouseEvent<HTMLButtonElement>);
    };

    return (
        <Modal onOk={onSaveProfile} okButtonProps={{ onKeyDown: handleKeyDown }} {...props}>
            <div className="flex h-full flex-col p-2 text-xs font-semibold">
                <div className="h-full  w-full p-2">
                    <div className="flex items-center">
                        Название:
                        <Input value={profileName} onChange={e => setProfileName(e.target.value)} className="ml-4" />
                    </div>
                    <div className="flex items-center">
                        Тип доступа:
                        <Select
                            style={{ width: '100%', marginTop: '16px' }}
                            options={PERMISSIONS.map(value => ({
                                value,
                                label: PERMISSION_TITLES[value],
                            }))}
                            value={permission}
                            onChange={setPermission}
                            className="ml-4"
                        />
                    </div>
                </div>
            </div>
        </Modal>
    );
};
